webpackJsonp([216929306842663],{

/***/ 40:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	module.exports=function(e){var t={};function n(i){if(t[i])return t[i].exports;var o=t[i]={i:i,l:!1,exports:{}};return e[i].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,i){n.o(e,t)||Object.defineProperty(e,t,{configurable:!1,enumerable:!0,get:i})},n.r=function(e){Object.defineProperty(e,"__esModule",{value:!0})},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=5)}({4:function(e,t){e.exports=__webpack_require__(2)},5:function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.VERTICAL=t.HORIZONTAL=void 0;var i,o=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(e[i]=n[i])}return e},r=function(){function e(e,t){for(var n=0;n<t.length;n++){var i=t[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}return function(t,n,i){return n&&e(t.prototype,n),i&&e(t,i),t}}(),s=n(4),a=(i=s)&&i.__esModule?i:{default:i};var l="previous",u="next",p=t.HORIZONTAL="horizontal",c=(t.VERTICAL="vertical",{previousButton:"previousButton",nextButton:"nextButton",buttonDisabled:"disabled",track:"track",slide:"slide",hidden:"hidden",previous:"previous",current:"current",next:"next",animateIn:"animateIn",animateOut:"animateOut"}),d=2e3,m={up:"rotate(90 10 15)",down:"rotate(270 10 15)",left:"rotate(180 10 15)",right:"rotate(0 10 15)"};function f(e){var t=e.direction,n=void 0===t?"right":t;return a.default.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"20",height:"30",viewBox:"0 0 20 30"},a.default.createElement("polygon",{fill:"#000",points:"20 15 4.228 0 0 3.626 11.954 15 0 26.374 4.228 30",transform:m[n]}))}var v=function(e){function t(e){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t);var n=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));n.setupAutoplay=function(){n.props.autoplay&&!n.isMouseOver&&(n.stopAutoplay(),n.autoplayTimerId=setInterval(n.next,parseInt(n.props.autoplay,10)))},n.stopAutoplay=function(){n.autoplayTimerId&&clearInterval(n.autoplayTimerId)},n.onAnimationEnd=function(){n.setState({currentSlideIndex:n.nextSlideIndex,animating:!1,animation:void 0}),n.setupAutoplay(),"function"==typeof n.props.onSlideChange&&n.props.onSlideChange({slideIndex:n.nextSlideIndex})},n.isDisabled=function(){return n.slideCount<2||n.state.animating||n.props.disabled},n.isInfinite=function(){return n.slideCount>2&&!1!==n.props.infinite},n.canGoPrevious=function(){return n.isInfinite()||n.state.currentSlideIndex>0},n.canGoNext=function(){return n.isInfinite()||n.state.currentSlideIndex<n.slideCount-1},n.goTo=function(e,t){n.isDisabled()||(n.nextSlideIndex=e,n.setState({animating:!0,animation:t}),setTimeout(n.onAnimationEnd,n.props.duration||d))},n.previous=function(){if(n.canGoPrevious()){var e=n.state.currentSlideIndex-1,t=e>=0?e:n.slideCount-1;n.goTo(t,l)}},n.next=function(){if(n.canGoNext()){var e=(n.state.currentSlideIndex+1)%n.slideCount;n.goTo(e,u)}},n.getSlideClass=function(e){var t=n.state,i=t.currentSlideIndex,o=t.animation,r=n.getClassNames(),s=n.slideCount-1;return e===i?o?r.animateOut+" "+r[o]:r.current:2===n.slideCount?o?r.animateIn+" "+r[o]:e<i?r.previous:r.next:e===i-1||0===i&&e===s?o===l?r.animateIn+" "+r.previous:o===u?r.hidden:r.previous:e===i+1||0===e&&i===s?o===u?r.animateIn+" "+r.next:o===l?r.hidden:r.next:r.hidden},n.isSwiping=!1,n.handleTouchStart=function(e){if(!n.isDisabled()){n.stopAutoplay();var t=n.getClassNames(),i=t.current,o=t.previous,r=t.next,s=e.touches[0];n.isSwiping=!0,n.pageStartPosition=s[n.swipeEventProperty],n.currentElement=n.sliderRef.getElementsByClassName(i)[0],n.previousElement=n.sliderRef.getElementsByClassName(o)[0],n.nextElement=n.sliderRef.getElementsByClassName(r)[0];var a=n.currentElement.getBoundingClientRect()[n.swipeProperty];n.currentElementStartPosition=0,n.currentElementPosition=0,n.currentElement.style.transition="none",n.previousElement&&(n.previousElement.style.transition="none",n.previousElement.style.visibility="visible",n.previousElementStartPosition=n.previousElement.getBoundingClientRect()[n.swipeProperty]-a),n.nextElement&&(n.nextElement.style.visibility="visible",n.nextElement.style.transition="none",n.nextElementStartPosition=n.nextElement.getBoundingClientRect()[n.swipeProperty]-a)}},n.animating=!1,n.handleTouchMove=function(e){e.preventDefault(),n.animating=n.animating||requestAnimationFrame(function(){if(n.isSwiping){var t=e.touches[0][n.swipeEventProperty]-n.pageStartPosition;n.currentElementPosition=n.currentElementStartPosition+t,n.currentElement.style[n.swipeProperty]=n.currentElementPosition+"px",n.previousElement&&(n.previousElementPosition=n.previousElementStartPosition+t,n.previousElement.style[n.swipeProperty]=n.previousElementPosition+"px"),n.nextElement&&(n.nextElementPosition=n.nextElementStartPosition+t,n.nextElement.style[n.swipeProperty]=n.nextElementPosition+"px"),n.animating=!1}else n.animating=!1})},n.handleTouchEnd=function(){n.animating=!1,n.isSwiping=!1,n.currentElement.style.removeProperty(n.swipeProperty),n.currentElement.style.removeProperty("transition"),n.previousElement&&(n.previousElement.style.removeProperty("visibility"),n.previousElement.style.removeProperty("transition"),n.previousElement.style.removeProperty(n.swipeProperty)),n.nextElement&&(n.nextElement.style.removeProperty("visibility"),n.nextElement.style.removeProperty("transition"),n.nextElement.style.removeProperty(n.swipeProperty));var e=n.currentElementStartPosition-n.currentElementPosition,t=n.props.minSwipeOffset||15;Math.abs(e)>t?e<0?n.previous():n.next():n.setupAutoplay()},n.getClassNames=function(){return o({},c,n.props.classNames)},n.initTouchEvents=function(e){!n.isDisabled()&&e&&(n.sliderRef=e,n.sliderRef.addEventListener("touchstart",n.handleTouchStart),n.sliderRef.addEventListener("touchmove",n.handleTouchMove,{passive:!1}),n.sliderRef.addEventListener("touchend",n.handleTouchEnd))},n.handleMouseOver=function(){n.isMouseOver=!0,n.stopAutoplay()},n.handleMouseOut=function(){n.isMouseOver=!1,n.setupAutoplay()};var i=n.props,r=i.slideIndex,s=void 0===r?0:r,m=i.direction,f=void 0===m?p:m;return n.state={currentSlideIndex:s,animating:!1},n.slideCount=a.default.Children.count(n.props.children),n.direction=f,n.swipeProperty=f===p?"left":"top",n.swipeEventProperty=f===p?"clientX":"clientY",n}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(t,a.default.PureComponent),r(t,[{key:"componentDidMount",value:function(){this.setupAutoplay()}},{key:"componentWillUnmount",value:function(){this.stopAutoplay()}},{key:"render",value:function(){var e=this,t=this.props,n=t.children,i=t.className,r=void 0===i?"slider":i,s=t.previousButton,l=void 0===s?a.default.createElement(f,{direction:this.direction===p?"left":"down"}):s,u=t.nextButton,c=void 0===u?a.default.createElement(f,{direction:this.direction===p?"right":"up"}):u,d=t.touchDisabled,m=t.autoplay,v=this.getClassNames(),y=this.isDisabled();return a.default.createElement("div",o({className:v.slider||r},!d&&{ref:this.initTouchEvents},m&&{onMouseOver:this.handleMouseOver,onMouseOut:this.handleMouseOut}),a.default.createElement("a",{onClick:this.previous,className:v.previousButton+(y||!this.canGoPrevious()?" "+v.buttonDisabled:"")},l),a.default.createElement("a",{onClick:this.next,className:v.nextButton+(y||!this.canGoNext()?" "+v.buttonDisabled:"")},c),a.default.createElement("div",{className:v.track},a.default.Children.map(n,function(t,n){return a.default.cloneElement(t,{key:n,className:[v.slide,e.getSlideClass(n),t.props.className].filter(function(e){return e}).join(" ")})})))}}]),t}();t.default=v}});

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BreakView = function BreakView(props) {
	  var label = props.breakLabel;
	  var className = props.breakClassName || 'break';
	
	  return _react2.default.createElement(
	    'li',
	    { className: className },
	    label
	  );
	};
	
	exports.default = BreakView;
	//# sourceMappingURL=BreakView.js.map

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageView = function PageView(props) {
	  var pageClassName = props.pageClassName;
	  var pageLinkClassName = props.pageLinkClassName;
	
	  var onClick = props.onClick;
	  var href = props.href;
	
	  var ariaLabel = 'Page ' + props.page + (props.extraAriaContext ? ' ' + props.extraAriaContext : '');
	  var ariaCurrent = null;
	
	  if (props.selected) {
	    ariaCurrent = 'page';
	    ariaLabel = 'Page ' + props.page + ' is your current page';
	
	    if (typeof pageClassName !== 'undefined') {
	      pageClassName = pageClassName + ' ' + props.activeClassName;
	    } else {
	      pageClassName = props.activeClassName;
	    }
	
	    if (typeof pageLinkClassName !== 'undefined') {
	      pageLinkClassName = pageLinkClassName;
	
	      if (typeof props.activeLinkClassName !== 'undefined') {
	        pageLinkClassName = pageLinkClassName + ' ' + props.activeLinkClassName;
	      }
	    } else {
	      pageLinkClassName = props.activeLinkClassName;
	    }
	  }
	
	  return _react2.default.createElement(
	    'li',
	    { className: pageClassName },
	    _react2.default.createElement(
	      'a',
	      { onClick: onClick,
	        role: 'button',
	        className: pageLinkClassName,
	        href: href,
	        tabIndex: '0',
	        'aria-label': ariaLabel,
	        'aria-current': ariaCurrent,
	        onKeyPress: onClick },
	      props.page
	    )
	  );
	};
	
	exports.default = PageView;
	//# sourceMappingURL=PageView.js.map

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PageView = __webpack_require__(228);
	
	var _PageView2 = _interopRequireDefault(_PageView);
	
	var _BreakView = __webpack_require__(227);
	
	var _BreakView2 = _interopRequireDefault(_BreakView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaginationBoxView = function (_Component) {
	  _inherits(PaginationBoxView, _Component);
	
	  function PaginationBoxView(props) {
	    _classCallCheck(this, PaginationBoxView);
	
	    var _this = _possibleConstructorReturn(this, (PaginationBoxView.__proto__ || Object.getPrototypeOf(PaginationBoxView)).call(this, props));
	
	    _this.handlePreviousPage = function (evt) {
	      var selected = _this.state.selected;
	
	      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
	      if (selected > 0) {
	        _this.handlePageSelected(selected - 1, evt);
	      }
	    };
	
	    _this.handleNextPage = function (evt) {
	      var selected = _this.state.selected;
	      var pageCount = _this.props.pageCount;
	
	
	      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
	      if (selected < pageCount - 1) {
	        _this.handlePageSelected(selected + 1, evt);
	      }
	    };
	
	    _this.handlePageSelected = function (selected, evt) {
	      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
	
	      if (_this.state.selected === selected) return;
	
	      _this.setState({ selected: selected });
	
	      // Call the callback with the new selected item:
	      _this.callCallback(selected);
	    };
	
	    _this.callCallback = function (selectedItem) {
	      if (typeof _this.props.onPageChange !== "undefined" && typeof _this.props.onPageChange === "function") {
	        _this.props.onPageChange({ selected: selectedItem });
	      }
	    };
	
	    _this.pagination = function () {
	      var items = [];
	      var _this$props = _this.props,
	          pageRangeDisplayed = _this$props.pageRangeDisplayed,
	          pageCount = _this$props.pageCount,
	          marginPagesDisplayed = _this$props.marginPagesDisplayed,
	          breakLabel = _this$props.breakLabel,
	          breakClassName = _this$props.breakClassName;
	      var selected = _this.state.selected;
	
	
	      if (pageCount <= pageRangeDisplayed) {
	
	        for (var index = 0; index < pageCount; index++) {
	          items.push(_this.getPageElement(index));
	        }
	      } else {
	
	        var leftSide = pageRangeDisplayed / 2;
	        var rightSide = pageRangeDisplayed - leftSide;
	
	        // If the selected page index is on the default right side of the pagination,
	        // we consider that the new right side is made up of it (= only one break element).
	        // If the selected page index is on the default left side of the pagination,
	        // we consider that the new left side is made up of it (= only one break element).
	        if (selected > pageCount - pageRangeDisplayed / 2) {
	          rightSide = pageCount - selected;
	          leftSide = pageRangeDisplayed - rightSide;
	        } else if (selected < pageRangeDisplayed / 2) {
	          leftSide = selected;
	          rightSide = pageRangeDisplayed - leftSide;
	        }
	
	        var _index = void 0;
	        var page = void 0;
	        var breakView = void 0;
	        var createPageView = function createPageView(index) {
	          return _this.getPageElement(index);
	        };
	
	        for (_index = 0; _index < pageCount; _index++) {
	
	          page = _index + 1;
	
	          // If the page index is lower than the margin defined,
	          // the page has to be displayed on the left side of
	          // the pagination.
	          if (page <= marginPagesDisplayed) {
	            items.push(createPageView(_index));
	            continue;
	          }
	
	          // If the page index is greater than the page count
	          // minus the margin defined, the page has to be
	          // displayed on the right side of the pagination.
	          if (page > pageCount - marginPagesDisplayed) {
	            items.push(createPageView(_index));
	            continue;
	          }
	
	          // If the page index is near the selected page index
	          // and inside the defined range (pageRangeDisplayed)
	          // we have to display it (it will create the center
	          // part of the pagination).
	          if (_index >= selected - leftSide && _index <= selected + rightSide) {
	            items.push(createPageView(_index));
	            continue;
	          }
	
	          // If the page index doesn't meet any of the conditions above,
	          // we check if the last item of the current "items" array
	          // is a break element. If not, we add a break element, else,
	          // we do nothing (because we don't want to display the page).
	          if (breakLabel && items[items.length - 1] !== breakView) {
	            breakView = _react2.default.createElement(_BreakView2.default, {
	              key: _index,
	              breakLabel: breakLabel,
	              breakClassName: breakClassName
	            });
	            items.push(breakView);
	          }
	        }
	      }
	
	      return items;
	    };
	
	    _this.state = {
	      selected: props.initialPage ? props.initialPage : props.forcePage ? props.forcePage : 0
	    };
	    return _this;
	  }
	
	  _createClass(PaginationBoxView, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          initialPage = _props.initialPage,
	          disableInitialCallback = _props.disableInitialCallback;
	      // Call the callback with the initialPage item:
	
	      if (typeof initialPage !== 'undefined' && !disableInitialCallback) {
	        this.callCallback(initialPage);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (typeof nextProps.forcePage !== 'undefined' && this.props.forcePage !== nextProps.forcePage) {
	        this.setState({ selected: nextProps.forcePage });
	      }
	    }
	  }, {
	    key: 'hrefBuilder',
	    value: function hrefBuilder(pageIndex) {
	      var _props2 = this.props,
	          hrefBuilder = _props2.hrefBuilder,
	          pageCount = _props2.pageCount;
	
	      if (hrefBuilder && pageIndex !== this.state.selected && pageIndex >= 0 && pageIndex < pageCount) {
	        return hrefBuilder(pageIndex + 1);
	      }
	    }
	  }, {
	    key: 'getPageElement',
	    value: function getPageElement(index) {
	      var selected = this.state.selected;
	      var _props3 = this.props,
	          pageClassName = _props3.pageClassName,
	          pageLinkClassName = _props3.pageLinkClassName,
	          activeClassName = _props3.activeClassName,
	          activeLinkClassName = _props3.activeLinkClassName,
	          extraAriaContext = _props3.extraAriaContext;
	
	
	      return _react2.default.createElement(_PageView2.default, {
	        key: index,
	        onClick: this.handlePageSelected.bind(null, index),
	        selected: selected === index,
	        pageClassName: pageClassName,
	        pageLinkClassName: pageLinkClassName,
	        activeClassName: activeClassName,
	        activeLinkClassName: activeLinkClassName,
	        extraAriaContext: extraAriaContext,
	        href: this.hrefBuilder(index),
	        page: index + 1 });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          disabledClassName = _props4.disabledClassName,
	          previousClassName = _props4.previousClassName,
	          nextClassName = _props4.nextClassName,
	          pageCount = _props4.pageCount,
	          containerClassName = _props4.containerClassName,
	          previousLinkClassName = _props4.previousLinkClassName,
	          previousLabel = _props4.previousLabel,
	          nextLinkClassName = _props4.nextLinkClassName,
	          nextLabel = _props4.nextLabel;
	      var selected = this.state.selected;
	
	
	      var previousClasses = previousClassName + (selected === 0 ? ' ' + disabledClassName : '');
	      var nextClasses = nextClassName + (selected === pageCount - 1 ? ' ' + disabledClassName : '');
	
	      return _react2.default.createElement(
	        'ul',
	        { className: containerClassName },
	        _react2.default.createElement(
	          'li',
	          { className: previousClasses },
	          _react2.default.createElement(
	            'a',
	            { onClick: this.handlePreviousPage,
	              className: previousLinkClassName,
	              href: this.hrefBuilder(selected - 1),
	              tabIndex: '0',
	              role: 'button',
	              onKeyPress: this.handlePreviousPage },
	            previousLabel
	          )
	        ),
	        this.pagination(),
	        _react2.default.createElement(
	          'li',
	          { className: nextClasses },
	          _react2.default.createElement(
	            'a',
	            { onClick: this.handleNextPage,
	              className: nextLinkClassName,
	              href: this.hrefBuilder(selected + 1),
	              tabIndex: '0',
	              role: 'button',
	              onKeyPress: this.handleNextPage },
	            nextLabel
	          )
	        )
	      );
	    }
	  }]);
	
	  return PaginationBoxView;
	}(_react.Component);
	
	PaginationBoxView.propTypes = {
	  pageCount: _propTypes2.default.number.isRequired,
	  pageRangeDisplayed: _propTypes2.default.number.isRequired,
	  marginPagesDisplayed: _propTypes2.default.number.isRequired,
	  previousLabel: _propTypes2.default.node,
	  nextLabel: _propTypes2.default.node,
	  breakLabel: _propTypes2.default.node,
	  hrefBuilder: _propTypes2.default.func,
	  onPageChange: _propTypes2.default.func,
	  initialPage: _propTypes2.default.number,
	  forcePage: _propTypes2.default.number,
	  disableInitialCallback: _propTypes2.default.bool,
	  containerClassName: _propTypes2.default.string,
	  pageClassName: _propTypes2.default.string,
	  pageLinkClassName: _propTypes2.default.string,
	  activeClassName: _propTypes2.default.string,
	  activeLinkClassName: _propTypes2.default.string,
	  previousClassName: _propTypes2.default.string,
	  nextClassName: _propTypes2.default.string,
	  previousLinkClassName: _propTypes2.default.string,
	  nextLinkClassName: _propTypes2.default.string,
	  disabledClassName: _propTypes2.default.string,
	  breakClassName: _propTypes2.default.string
	};
	PaginationBoxView.defaultProps = {
	  pageCount: 10,
	  pageRangeDisplayed: 2,
	  marginPagesDisplayed: 3,
	  activeClassName: "selected",
	  previousClassName: "previous",
	  nextClassName: "next",
	  previousLabel: "Previous",
	  nextLabel: "Next",
	  breakLabel: "...",
	  disabledClassName: "disabled",
	  disableInitialCallback: false
	};
	exports.default = PaginationBoxView;
	;
	//# sourceMappingURL=PaginationBoxView.js.map

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PaginationBoxView = __webpack_require__(229);
	
	var _PaginationBoxView2 = _interopRequireDefault(_PaginationBoxView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _PaginationBoxView2.default;
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactPaginate = __webpack_require__(230);
	
	var _reactPaginate2 = _interopRequireDefault(_reactPaginate);
	
	var _BlogPost = __webpack_require__(137);
	
	var _BlogPost2 = _interopRequireDefault(_BlogPost);
	
	__webpack_require__(180);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlogList = function (_Component) {
	  _inherits(BlogList, _Component);
	
	  function BlogList(props) {
	    _classCallCheck(this, BlogList);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.handlePageClick = function (data) {
	      var selected = data.selected;
	      var offset = Math.ceil(selected * _this.limit);
	      _this.setState(_extends({}, _this.state, {
	        offset: offset,
	        data: _this.blogList.slice(offset, offset + _this.limit)
	      }));
	    };
	
	    _this.blogList = props.posts.filter(function (post) {
	      return post.node.frontmatter.templateKey === 'article-page';
	    });
	    _this.limit = props.itemsPerPage || 5;
	    _this.isfrontPage = props.isFrontPage || false;
	    _this.state = {
	      data: _this.blogList.slice(0, _this.limit),
	      offset: 0,
	      pageCount: Math.ceil(_this.blogList.length / _this.limit)
	    };
	    return _this;
	  }
	
	  BlogList.prototype.render = function render() {
	    var isFrontPage = this.isfrontPage;
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_BlogPost2.default, { posts: this.state.data }),
	      isFrontPage == false ? _react2.default.createElement(
	        'div',
	        { className: 'pager-container' },
	        _react2.default.createElement(_reactPaginate2.default, {
	          previousLabel: '<',
	          nextLabel: '>',
	          breakLabel: _react2.default.createElement(
	            'a',
	            { href: '' },
	            '...'
	          ),
	          pageCount: this.state.pageCount,
	          marginPagesDisplayed: 2,
	          pageRangeDisplayed: 3,
	          onPageChange: this.handlePageClick,
	          activeClassName: 'active',
	          breakClassName: 'pager-button',
	          containerClassName: 'pager',
	          pageClassName: 'pager-button',
	          previousClassName: 'previous pager-button',
	          nextClassName: 'next pager-button'
	        })
	      ) : null
	    );
	  };
	
	  return BlogList;
	}(_react.Component);
	
	BlogList.propTypes = {
	  posts: _propTypes2.default.object.isRequired,
	  itemsPerPage: _propTypes2.default.number
	};
	
	exports.default = BlogList;
	module.exports = exports['default'];

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(26);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogPost = function BlogPost(_ref) {
	  var posts = _ref.posts;
	
	  console.log('-->BlogPost: ' + JSON.stringify(posts));
	  return _react2.default.createElement(
	    'div',
	    { className: 'container' },
	    posts.filter(function (post) {
	      return post.node.frontmatter.templateKey === 'article-page';
	    }).map(function (_ref2) {
	      var post = _ref2.node;
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'content',
	          style: { border: '1px solid #eaecee', padding: '2em 4em' },
	          key: post.id
	        },
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: 'has-text-primary', to: post.fields.slug },
	            post.frontmatter.title
	          ),
	          _react2.default.createElement(
	            'span',
	            null,
	            ' \u2022 '
	          ),
	          _react2.default.createElement(
	            'small',
	            null,
	            post.frontmatter.date
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          post.excerpt,
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: 'button is-small', to: post.fields.slug },
	            'Keep Reading \u2192'
	          )
	        )
	      );
	    })
	  );
	};
	
	BlogPost.propTypes = {
	  posts: _propTypes2.default.object
	};
	
	exports.default = BlogPost;
	module.exports = exports['default'];

/***/ }),

/***/ 180:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SlidesQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactAnimatedSlider = __webpack_require__(43);
	
	var _reactAnimatedSlider2 = _interopRequireDefault(_reactAnimatedSlider);
	
	__webpack_require__(40);
	
	__webpack_require__(41);
	
	__webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CarouselTemplate = function CarouselTemplate(_ref) {
	  var autoplay = _ref.autoplay,
	      deck = _ref.deck;
	  return _react2.default.createElement(
	    'div',
	    { className: 'container' },
	    _react2.default.createElement(
	      _reactAnimatedSlider2.default,
	      { className: 'slider-wrapper', autoplay: autoplay * 1000 },
	      deck.map(function (slide, index) {
	        return _react2.default.createElement(
	          'div',
	          { key: index,
	            className: 'slider-content',
	            style: {
	              backgroundImage: 'url(\'' + slide.image + '\')'
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'inner' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              slide.title
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              slide.text
	            )
	          )
	        );
	      })
	    )
	  );
	};
	
	CarouselTemplate.propTypes = {
	  autoplay: _propTypes2.default.number,
	  deck: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    image: _propTypes2.default.string,
	    title: _propTypes2.default.string,
	    text: _propTypes2.default.string
	  }))
	};
	
	var Carousel = function Carousel(_ref2) {
	  var slideDeck = _ref2.slideDeck;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(CarouselTemplate, { autoplay: slideDeck.autoplay, deck: slideDeck.deck })
	  );
	};
	
	Carousel.propTypes = {
	  slideDeck: _propTypes2.default.object
	};
	
	exports.default = Carousel;
	var SlidesQuery = exports.SlidesQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 42:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Services = function Services(_ref) {
	  var gridItems = _ref.gridItems;
	  return _react2.default.createElement(
	    'div',
	    { className: 'columns is-multiline' },
	    gridItems.map(function (item) {
	      return _react2.default.createElement(
	        'div',
	        { key: item.image, className: 'column is-6 is-flex' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section', style: { border: '1px solid #89898966', borderRadius: '5px' } },
	          _react2.default.createElement(
	            'h2',
	            { className: 'has-text-centered title is-2' },
	            item.servHeader
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'has-text-centered' },
	            _react2.default.createElement('img', { alt: '', src: item.image })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            item.text
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: item.servLink },
	              'More information'
	            )
	          )
	        )
	      );
	    })
	  );
	};
	
	Services.propTypes = {
	  gridItems: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    image: _propTypes2.default.string,
	    text: _propTypes2.default.string,
	    servHeader: _propTypes2.default.string,
	    servLink: _propTypes2.default.string
	  }))
	};
	
	exports.default = Services;
	module.exports = exports['default'];

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = exports.HomePageTemplate = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(21);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Services = __webpack_require__(340);
	
	var _Services2 = _interopRequireDefault(_Services);
	
	var _BlogList = __webpack_require__(136);
	
	var _BlogList2 = _interopRequireDefault(_BlogList);
	
	var _Carousel = __webpack_require__(37);
	
	var _Carousel2 = _interopRequireDefault(_Carousel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import Testimonials from '../components/Testimonials'
	
	/**
	 * Created by vaibhav on 31/3/18
	 */
	var HomePageTemplate = exports.HomePageTemplate = function HomePageTemplate(_ref) {
	  var title = _ref.title,
	      heading = _ref.heading,
	      subheading = _ref.subheading,
	      description = _ref.description,
	      services = _ref.services,
	      meta_title = _ref.meta_title,
	      meta_description = _ref.meta_description,
	      slideDeck = _ref.slideDeck,
	      posts = _ref.posts;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        meta_title
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: meta_description }),
	      _react2.default.createElement('link', { rel: 'icon',
	        type: 'image/png',
	        href: '/img/pesilogo_32x32.png' })
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'hero is-primary is-bold' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'hero-body' },
	          _react2.default.createElement(
	            'div',
	            { className: 'columns' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-12 ' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'title', id: 'content' },
	                title
	              ),
	              _react2.default.createElement(
	                'h2',
	                { className: ' subtitle' },
	                subheading
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: {
	          margin: '0 auto',
	          maxWidth: 960,
	          padding: '0px 1.0875rem 1.45rem',
	          paddingTop: 0
	        } },
	      _react2.default.createElement(
	        'section',
	        { className: 'section section--gradient' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'columns' },
	              _react2.default.createElement(
	                'div',
	                { className: 'column' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'content ' },
	                  _react2.default.createElement(
	                    'h3',
	                    { className: 'has-text-weight-semibold  has-text-centered' },
	                    heading
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'has-text-justified' },
	                    description
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(_Services2.default, { gridItems: services.blurbs })
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'title' },
	            'Latest News'
	          ),
	          _react2.default.createElement(_BlogList2.default, { posts: posts, itemsPerPage: 4, isFrontPage: true }),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Older news items are available via our full ',
	            _react2.default.createElement(
	              'a',
	              { href: '/news' },
	              'News archive'
	            ),
	            '.'
	          )
	        )
	      )
	    )
	  );
	};
	
	HomePageTemplate.propTypes = {
	  title: _propTypes2.default.string,
	  meta_title: _propTypes2.default.string,
	  meta_description: _propTypes2.default.string,
	  heading: _propTypes2.default.string,
	  subheading: _propTypes2.default.string,
	  description: _propTypes2.default.string,
	  services: _propTypes2.default.shape({
	    blurbs: _propTypes2.default.array
	  }),
	  slideDeck: _propTypes2.default.object,
	  edges: _propTypes2.default.array
	};
	
	var HomePage = function HomePage(_ref2) {
	  var data = _ref2.data;
	  var frontmatter = data.markdownRemark.frontmatter;
	
	  var slideDeck = data.allSlideDecksJson.edges.filter(function (edge) {
	    return edge.node.deckName === 'Employees';
	  })[0].node;
	  var posts = data.allMarkdownRemark.edges;
	
	
	  return _react2.default.createElement(HomePageTemplate, {
	    title: frontmatter.title,
	    meta_title: frontmatter.meta_title,
	    meta_description: frontmatter.meta_description,
	    heading: frontmatter.heading,
	    subheading: frontmatter.subheading,
	    description: frontmatter.description,
	    services: frontmatter.services,
	    testimonials: frontmatter.testimonials,
	    slideDeck: slideDeck,
	    posts: posts
	  });
	};
	
	HomePage.propTypes = {
	  data: _propTypes2.default.shape({
	    allSlidesJson: _propTypes2.default.shape({
	      edges: _propTypes2.default.Array
	    }),
	    markdownRemark: _propTypes2.default.shape({
	      frontmatter: _propTypes2.default.object
	    }),
	    allMarkdownRemark: _propTypes2.default.shape({
	      edges: _propTypes2.default.object
	    })
	  })
	};
	
	exports.default = HomePage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-home-page-js-1f2b9e6a96d5d51dcd81.js